<template>
  <div class="container">
       <div class="imgcon">
       <img src="@/assets/images/img/img6.png" alt="" srcset="">
     </div>

   <div class="bigtextCon">
     <div class="p1con">
       Let's connect
       <img src="@/assets/images/img/img8.png" alt="" srcset="">
     </div>
     <div class="p2con">
       Send over any questions or inquiries you may have. We’re always ready to start a new project or make a collaboration.
     </div>
   </div>

    <div class="con">
      <div class="let">
              <div>
 <div class="p1">Company</div>
        <div class="p2">METAFORCE CRYPTO TECHNOLOGY LIMITED</div>
        </div>
        <div class="t2">
 <div class="p1">Email</div>
        <div class="p2">service@bitcooo.com</div>
        </div>
             <div class="t2">
 <div class="p1">Address</div>
        <div class="p2">1312 17th St Ste 1049 Denver CO 80202</div>
        </div>
        <div class="botex">
    Feel free to share your questions, concerns and suggestions by filling out the contact form.
        </div>
      </div>
      <div class="rig">
        <el-form :model="form" status-icon :rules="rules" ref="form" label-width="100px" class="demo-ruleForm">
  <el-form-item  prop="name">
    <div class="tx">Name</div>
    <el-input type="text"  placeholder="Enter Name" v-model="form.name" autocomplete="off"></el-input>
  </el-form-item>
  <el-form-item prop="email">
     <div class="tx">Email</div>
    <el-input type="text" placeholder="Enter Email" v-model="form.email" autocomplete="off"></el-input>
  </el-form-item>
    <el-form-item prop="phoneNumber">
     <div class="tx">Phone Number</div>
    <el-input type="text" placeholder="Enter Number" v-model="form.phoneNumber" autocomplete="off"></el-input>
  </el-form-item>
    <el-form-item prop="message">
     <div class="tx">Message</div>
    <el-input type="text" placeholder="Enter your Message" v-model="form.message" autocomplete="off"></el-input>
  </el-form-item>
  <el-form-item>
    <el-button type="primary" @click="submitForm('form')">Contact Us
       <img src="@/assets/images/img/img7.png" alt="" srcset="" class="btnimg">
    </el-button>
  </el-form-item>
</el-form>
      </div>
    </div>

  </div>
</template>

<script>
import { common_api } from "../../api/ymdfbaby";
export default {
  name: "detail",
  props: {},
  data() {
      return {
        form:{
    name: '',
          email: '',
         phoneNumber: '',
          message:'',
        },

        rules: {
     name: [
            { required: true, message: 'Please enter a name', trigger: 'blur' },
          ],
       email: [
          { required: true, message: 'Please enter email address', trigger: 'blur' },
        { type: 'email', message: 'Please enter the correct email address', trigger: ['blur', 'change'] }
          ],

       phoneNumber: [
            { required: true, message: 'Please enter your mobile phone number', trigger: 'blur' },
          ],
             message: [
            { required: true, message: 'Please enter comments', trigger: 'blur' },
          ],
        }
      };
    },
    methods: {
      submitForm(formName) {
                console.log(JSON.parse(JSON.stringify(this.form)))

        this.$refs[formName].validate((valid) => {
          if (valid) {
              common_api.addContact(JSON.parse(JSON.stringify(this.form))).then((res) => {
        if(res.code==200){
           this.$message({
          message: 'Added successfully',
          type: 'success'
        });
        this.form={
          name: '',
          email: '',
         phoneNumber: '',
          message:'',
        }
        }else{
          console.log(res,7777)
         this.$message.error('Add failed');
        }
      });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.botex{
  font-size: 32px;
  width: 80%;
  margin-top: 180px;
}
.bigtextCon{
  margin-top: 65px;
  padding-bottom: 24px;
  border-bottom: 1px solid #F2F4F7;
  .p1con{
    font-size: 56px;
    img{
      width: 46px;
      height: 42px;
      margin-left: 6px;
    }
  }
  .p2con{
  margin-top: 30px;
  font-size: 32px;
  }
}

// /deep/ .el-button--primary:focus, .el-button--primary:hover{
//   background: #5B53FF;

// }
/deep/ .el-button--primary{
  width: 190px !important;
  background: #5B53FF;
  position: relative;
  color: #fff !important;
}
.btnimg{
vertical-align: top;
margin-left: 5px;
}
/deep/ .el-button{
  width: 131px;
  min-height: 56px;
  border-radius: 0;
  font-size: 16px;
  border: 1px solid #5B53FF;
  color: #5B53FF;
}
/deep/ .el-textarea__inner{
  height: 179px !important;
  padding-top: 21px;
  padding-left: 14px;
  border-radius: 0;
    font-size: 20px;
  color: #5B53FF;
  border-color: #000000;
}
/deep/ .el-textarea__inner:focus{
  border: 1px solid #5B53FF;

}
/deep/ .el-input__inner:focus{
  border-bottom: 1px solid #5B53FF;

}
/deep/ .el-input__inner{
  padding-left: 0;
  border-top: none;
  border-left: none;
  border-right: none;
  height: 52px;
  border-bottom: 1px solid #0D1022;
  font-size: 20px;
  color: #5B53FF;
  border-radius: 0;
}
.container{
   margin: 0 auto;
  .imgcon{
    width: 100%;
    margin-top: 80px;
    img{
      width: 100%;
    }
  }
  .con{
    display: flex;
    justify-content: space-between;
    margin-top: 77px;
    padding-bottom: 134px;
    .let{
      width: 40%;
      .t2{
        margin-top: 40px;
      }
      .p1{
        font-size: 24px;
        color: #5B53FF;
      }
      .p2{
        font-size: 18px;
        width: 65%;
        margin-top: 28px;
      }
    }
    .rig{
      width: 60%;
    }
  }
}

@media (max-width: 1680px) {

}
@media (max-width: 1459px) {
.botex{


width: 90%;
    margin-top: 60px;
}
}
@media (max-width: 500px) {
  .container .con .rig{
    width: 100%;
    margin-top: 45px;
  }
 /deep/ .el-form-item__content
  {
    margin: 0 !important;
  }
  .botex{
    width: 100%;
    font-size: 20px;
    margin-top: 68px;
    padding-top: 32px;
    border-top: 1px solid #F2F4F7;
}

  .container .con .let .p2{
    width: 100%;
  }
  .container .con {
    margin-top: 45px;
  }
  .container .con .let {
    width: 100%;
}

  .container .con{
    display: block;
  }
  .bigtextCon{
    margin-top: 40px;
  }
  .bigtextCon .p2con{
    font-size: 20px;
}
  .bigtextCon .p1con img {
    width: 28px;
    height: 28px;
  }
.container{
  padding: 0 25px;
}
.bigtextCon .p1con {
    font-size: 34px;
}
}
</style>
